module.exports = __webpack_public_path__ + "static/media/copy-btn-icon.8385d32c.svg";